import styled from "@emotion/styled";
import { Button, ButtonGroup, Toast, ToastContainer } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import { useIsClient } from "@uidotdev/usehooks";
import { GoogleAnalytics } from "@next/third-parties/google";
import { googleAnalytics4Id } from "@/utilities/constants";
import { useConsent } from "@/hooks/useConsent";

const StyledPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const NoHoverButton = styled(Button)`
  &:hover {
    background-color: inherit;
    border-color: var(--color-primary);
    color: var(--color-primary);
  }
`;

const PageContainer = ({ children }: { children: React.ReactNode }) => {
  const { consentWasGiven, giveConsent, denyConsent } = useConsent();
  const isClient = useIsClient();

  return (
    <StyledPageContainer>
      {children}
      {consentWasGiven && <GoogleAnalytics gaId={googleAnalytics4Id} />}
      <ToastContainer position="bottom-start">
        <Toast show={isClient && consentWasGiven === undefined}>
          <Toast.Body>
            <p>
              <FormattedMessage
                id="PageContainer.loading"
                defaultMessage="Analytics help us improve the product. Are you willing to share this information? You can find our privacy policy {here}."
                values={{
                  here: (
                    <Link href="/privacy-policy" target="_blank">
                      <FormattedMessage id="PageContainer.here" defaultMessage="here" />
                    </Link>
                  ),
                }}
              />
            </p>
            <StyledButtonGroup>
              <NoHoverButton variant="outline-primary" onClick={denyConsent}>
                <FormattedMessage id="PageContainer.IDecline" defaultMessage="I decline" />
              </NoHoverButton>
              <Button variant="primary" onClick={giveConsent}>
                <FormattedMessage id="PageContainer.IAccept" defaultMessage="I accept" />
              </Button>
            </StyledButtonGroup>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </StyledPageContainer>
  );
};

export default PageContainer;
